import { render, staticRenderFns } from "./DataAnalyticsListTable.vue?vue&type=template&id=b717c420&scoped=true&"
import script from "./DataAnalyticsListTable.vue?vue&type=script&lang=js&"
export * from "./DataAnalyticsListTable.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalyticsListTable.vue?vue&type=style&index=0&id=b717c420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b717c420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable,VFlex,VIcon})
